"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APAutoTabInput.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-auto-tab-input';
var InnerInput = /*#__PURE__*/function (_React$Component) {
  function InnerInput(props) {
    var _this;
    _classCallCheck(this, InnerInput);
    _this = _callSuper(this, InnerInput, [props]);
    _defineProperty(_this, "handleChange", function (e, index) {
      var target = e.target;
      var value = target.value;
      var _this$props = _this.props,
        maxLength = _this$props.maxLength,
        type = _this$props.type;
      if (isNaN(value) && type === 'number') return;
      var newValues = _this.state.values.slice();
      if (value.length <= maxLength) {
        newValues[index] = value;
        _this.setNewValues(newValues);
      } else if (value.length > maxLength && index < _this.props.numberOfInputs - 1) {
        newValues[index + 1] = value.substr(value.length - 1, 1);
        _this.setNewValues(newValues);
      }
    });
    _defineProperty(_this, "handlePaste", function (e) {
      // Prevent handleKeyUp & handleChange from firing.
      e.preventDefault();
      var paste = (e.clipboardData || window.clipboardData).getData('text');
      var newState = _this.state.values.map(function (i, idx) {
        if (paste[idx]) return paste[idx];
        return i;
      });
      _this.setNewValues(newState);
      _this.props.input.onChange(_this.state.values.join(''));
      _this.divRef.current.children[_this.divRef.current.children.length - 1].focus();
    });
    _defineProperty(_this, "handleKeyUp", function (e, _index) {
      var type = _this.props.type;
      var value = e.target.value;
      var backspaceCode = 8;
      if (isNaN(value) && type === 'number') return;
      if (e.keyCode === backspaceCode && e.target.value.length === 0) {
        var prev = e.target.previousElementSibling;
        while (prev) {
          if (prev === null) break;
          if (prev.tagName.toLowerCase() === 'input') {
            prev.focus();
            break;
          }
          prev = prev.previousElementSibling;
        }
      } else if (e.target.value.length === _this.props.maxLength) {
        var next = e.target.nextElementSibling;
        while (next) {
          if (next === null) break;
          if (next.tagName.toLowerCase() === 'input') {
            next.focus();
            break;
          }
          next = next.nextElementSibling;
        }
      }
    });
    _this.divRef = /*#__PURE__*/(0, _react.createRef)();
    _this.state = {
      values: Array(props.numberOfInputs).fill('')
    };
    return _this;
  }
  _inherits(InnerInput, _React$Component);
  return _createClass(InnerInput, [{
    key: "setNewValues",
    value: function setNewValues(newValues) {
      var _this2 = this;
      this.setState({
        values: newValues
      }, function () {
        _this2.props.input.onChange(_this2.state.values.join(''));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        info = _this$props2.info,
        meta = _this$props2.meta,
        label = _this$props2.label,
        customClass = _this$props2.customClass;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
      var inputs = this.state.values.map(function (value, index) {
        return /*#__PURE__*/_react["default"].createElement("input", {
          key: index,
          className: bemClasses(),
          onKeyUp: function onKeyUp(e) {
            return _this3.handleKeyUp(e, index);
          },
          onChange: function onChange(e) {
            return _this3.handleChange(e, index);
          },
          value: _this3.state.values[index],
          autoFocus: !index,
          onPaste: _this3.handlePaste
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'form-group',
        ref: this.divRef
      }, this.props.type !== 'hidden' && label && /*#__PURE__*/_react["default"].createElement("label", {
        className: bemClasses('label')
      }, label), inputs, info && /*#__PURE__*/_react["default"].createElement("small", {
        className: 'form-text-muted'
      }, info), meta.touched && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(bemClasses('error'))
      }, meta.error));
    }
  }]);
}(_react["default"].Component);
var APAutoTabInput = function APAutoTabInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerInput
  }, props));
};
APAutoTabInput.defaultProps = {
  maxLength: 1
};
APAutoTabInput.propTypes = {
  name: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  numberOfInputs: _propTypes["default"].number.isRequired,
  maxLength: _propTypes["default"].number
};
var _default = exports["default"] = APAutoTabInput;